import { TransformDate } from 'src/app/common/util/transform-date';
import { Receiver } from './receiver';
import { MessageType } from './message-type';
import { Expose, Type } from 'class-transformer';

export class ChatMessage {

    @Expose()
    id?: number;
    @Expose()
    message?: string;
    @Expose()
    @Type(() => Receiver)
    receivers?: Receiver[];
    @Expose()
    @TransformDate()
    date: Date;
    @Expose()
    username?: string;
    @Expose()
    channel: string;
    @Expose()
    type: MessageType;
    @Expose()
    readed?: boolean;


    static getName(): string {
        return 'chatMessages';
    }
}
